import { Icon } from '@iconify/react/dist/iconify.js';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { useFetch } from '../hook/useFecth';
import useErrors from '../hook/useErrors';
import server from '../services/server';
import Select from 'react-select';
import useDialog from '../hook/useDialog';
import { Modal } from 'react-bootstrap';
import { useConfirm } from '../context/BootstrapConfirm';


import ItemPedidoModal from './Modal/ItemPedidoModal';
import { useNavigate } from 'react-router-dom';
import { statusPedido, getProximoStatus, statusPedidoNome } from '../helper/helpers';
import OrderPaymentModal from './Modal/PagamentoModal';
import PedidoContratoModal from './Modal/ContratoModal';
import PedidoPdf from './PedidoPdf';
// import UploadImagensModal from './Modal/UploadImagensModal';
import PedidoImagesTab from './PedidoImagesTab';
import { formatCurrency, parseCurrency } from '../helper/currency';
import { PriceInputMasked } from './masks/PriceInputMasked';



function ViewPedidosLayer({ data, mutate, backTo = '/pedidos' }) {
    const { setErrors, toast } = useErrors();
    const confirm = useConfirm();
    const { data: cliente } = useFetch(`cliente`, { params: { select: true } });

    const { data: user } = useFetch(`/profile`);
    const { handleOpen: handleOpenProduct } = useDialog('product');
    const { handleOpen: handlePagamento } = useDialog('payment');
    const { handleOpen: handleContratoDetalhes } = useDialog('contrato');
    // const { handleOpen: handlePedidoExtra } = useDialog('pedidoExtra');
    const [activeTab, setActiveTab] = useState('detalhes');
    const [showContratoConfirm, setShowContratoConfirm] = useState(false);
    const [salvandoStatus, setSalvandoStatus] = useState(false);
    const { data: tiposFrete, mutate: mutateTiposFrete } = useFetch(`pedido/tipo-frete`);
    const [showTipoFreteModal, setShowTipoFreteModal] = useState(false);
    const [novoTipoFreteNome, setNovoTipoFreteNome] = useState('');
    const [submittingTipoFrete, setSubmittingTipoFrete] = useState(false);
    const [salvandoFrete, setSalvandoFrete] = useState(false);



    const navigate = useNavigate();
    const isFuncionario = user?.funcao === 'FUNCIONARIO';

    const { getFieldProps, errors, isSubmitting, isValid, handleSubmit, handleBlur, setFieldValue, touched, values, setValues, resetForm } =
        useFormik({
            initialValues: {
                nome: '',
                clienteId: '',
                produtos: [], // Array de produtos do pedido
                observacoes: '',
                action: 'create',
                enviar_producao: false,
                enderecoId: '',
                tipoFreteId: '',
                valorFrete: '',
            },
            // validationSchema: validationSchema,
            validateOnMount: true,
            validateOnChange: true,
            onSubmit: async (values, { setSubmitting, resetForm }) => {
                try {
                    console.log("On Submit")
                    if (values.action === 'update') {
                        const updateData = isFuncionario
                            ? { observacoes: values.observacoes }
                            : {
                                observacoes: values.observacoes,
                                enderecoId: values.enderecoId,
                                cliente_id: values.clienteId,
                            };
                        await server.put(`pedido/${values.id}`, updateData);
                        if (typeof mutate === 'function') mutate();
                        toast.success('Pedido alterado com sucesso!');
                        setSubmitting(false);
                    }
                    if (values.action === 'create') {
                        console.log(values)
                        console.log("create")
                        const { data } = await server.post(`pedido`, values);

                        toast.success('Pedido criado com sucesso!');
                        navigate(`/pedidos/${data?.id}`);
                        setSubmitting(false);
                    }
                    if (values.action === 'pagamento') {

                        const { data } = await server.post(`pedido`, values);

                        toast.success('Pedido alterado com sucesso!');
                        navigate(`/pedidos/${data?.id}`);
                        setSubmitting(false);
                    }
                    if (values.action === 'contrato') {

                        console.log("acessou contrato")

                        const { data } = await server.post(`pedido/${values?.id}/contrato`, values);

                        setShowContratoConfirm(false);
                        toast.success('Contrato criado com sucesso!');
                        navigate(`/pedidos/${values?.id}`);
                        setSubmitting(false);
                        console.log("enviou contrato")
                    }
                    if (values.enviar_producao) {
                        await server.patch(`pedido/${values.id}`, { status: "PRONTO_PARA_PRODUCAO" });
                    }
                    if (values.action === 'avancarStatus') {
                        await server.put(`pedido/${values.id}`, { status: values.proximoStatus });
                        if (typeof mutate === 'function') mutate();
                        toast.success('Status atualizado com sucesso!');
                        setSubmitting(false);
                    }
                    if (typeof mutate === 'function') await mutate();
                } catch (error) {
                    setSubmitting(false);
                    console.log(error);
                    setErrors(error);
                }
            },
        });
    useEffect(() => {
        if (Boolean(data)) {
            setValues({
                ...values,
                ...data,
                action: 'update',
                produtos: data?.item || [] // Carregar produtos do pedido no Formik
            }, true);
        }
    }, [data]);

    const pdfRef = useRef(null);
    const podeImprimir = Boolean(data?.id) && Boolean(data?.pedidoItems?.length);

    const handleImprimir = () => {
        pdfRef.current?.gerarPdf();
    };

    const handleEnviarProducao = () => {
        setFieldValue('enviar_producao', true);
        handleSubmit()
    };

    function handleCheckboxChange(e) {
        setFieldValue('status', e.target.checked);
    };

    // Função para atualizar produtos no Formik
    const atualizarProdutos = (novosProdutos) => {
        setFieldValue('produtos', novosProdutos);
    };

    const options = cliente?.map(i => ({
        value: i.id,
        label: i.nome,
        /** API `select` retorna só endereço principal */
        enderecoId: i?.enderecos?.[0]?.id,
    }));
    const selecionado = options?.find(item => item.value === values?.clienteId) || null;

    const { data: clienteEndereco } = useFetch(Boolean(data?.id) ? `cliente/${data?.clienteId}/endereco` : null);

    /** API pode retornar array ou um único objeto; sem isso `.find`/`.map` quebram */
    const enderecosLista = useMemo(
        () =>
            Array.isArray(clienteEndereco)
                ? clienteEndereco
                : clienteEndereco != null
                    ? [clienteEndereco]
                    : [],
        [clienteEndereco],
    );

    const enderecoOpcoes = selecionado
        ? enderecosLista.map((i) => ({
            value: i.id,
            label: i.descricao || [i.logradouro, i.numero, i.bairro, i.cidade].filter(Boolean).join(', '),
            dataEndereco: i,
        }))
        : [];

    /** Endereço padrão: lista de clientes (principal) ou lista carregada */
    const enderecoIdPadraoCliente =
        selecionado?.enderecoId ??
        enderecosLista.find((e) => e?.principal)?.id ??
        enderecosLista[0]?.id;

    /** Valor efetivo: o salvo no pedido / formulário, ou o padrão do cliente selecionado */
    const enderecoIdEfetivo =
        values?.enderecoId || data?.enderecoId || enderecoIdPadraoCliente;

    const enderecoSelecionado =
        enderecoOpcoes.find((item) => String(item.value) === String(enderecoIdEfetivo)) || null;

    useEffect(() => {
        if (!selecionado?.value || !enderecosLista.length || !enderecoIdPadraoCliente) return;
        const current = values.enderecoId || data?.enderecoId;
        const validoNaLista =
            current != null &&
            current !== '' &&
            enderecosLista.some((e) => String(e.id) === String(current));
        if (!validoNaLista) {
            setFieldValue('enderecoId', enderecoIdPadraoCliente);
        }
    }, [selecionado?.value, enderecosLista, enderecoIdPadraoCliente, data?.enderecoId]);

    function handleContrato() {
        setShowContratoConfirm(true);
    }

    async function handleConfirmarContrato() {
        await setFieldValue('action', 'contrato');

        handleSubmit()
    }

    const pagamentoRecebido = Boolean(data?.valorTotal) ? data?.totalRecebido >= data?.valorTotal : false

    const proximoStatusInfo = getProximoStatus(values?.status);
    const { estilo, texto } = statusPedido[values?.status] || { estilo: 'info', texto: values?.status };

    function handleAvancarStatus() {
        if (proximoStatusInfo) {
            setFieldValue('action', 'avancarStatus');
            setFieldValue('proximoStatus', proximoStatusInfo.proximoStatus);
            handleSubmit();
        }
    }

    async function handleExcluirPedido() {
        try {
            await confirm({
                title: 'Excluir pedido',
                message: `Tem certeza que deseja excluir o pedido #${data?.id}? Essa ação não pode ser desfeita.`,
                confirmText: 'Excluir',
            });
            await server.delete(`pedido/${data.id}`);
            toast.success('Pedido excluído com sucesso!');
            navigate(backTo);
        } catch (error) {
            if (error) setErrors(error);
        }
    }

    async function handleCadastrarTipoFrete(e) {
        e?.preventDefault();
        const nome = novoTipoFreteNome.trim();
        if (!nome) {
            toast.error('Informe o nome do tipo de frete.');
            return;
        }
        try {
            setSubmittingTipoFrete(true);
            const { data: novoTipo } = await server.post(`pedido/tipo-frete`, { nome });
            toast.success('Tipo de frete cadastrado com sucesso.');
            await mutateTiposFrete?.();
            setFieldValue('tipoFreteId', novoTipo?.id);
            if (values?.id) {
                await server.put(`pedido/${values.id}`, { tipoFreteId: novoTipo?.id });
                if (typeof mutate === 'function') mutate();
            }
            setNovoTipoFreteNome('');
            setShowTipoFreteModal(false);
        } catch (error) {
            setErrors(error);
        } finally {
            setSubmittingTipoFrete(false);
        }
    }

    async function handleChangeTipoFrete(novoTipoFreteId) {
        setFieldValue('tipoFreteId', novoTipoFreteId);
        if (!values?.id) return;
        try {
            setSalvandoFrete(true);
            await server.put(`pedido/${values.id}`, { tipoFreteId: novoTipoFreteId || null });
            if (typeof mutate === 'function') mutate();
            toast.success('Tipo de frete atualizado com sucesso!');
        } catch (error) {
            setErrors(error);
        } finally {
            setSalvandoFrete(false);
        }
    }

    async function handleSalvarValorFrete() {
        if (!values?.id) return;
        try {
            setSalvandoFrete(true);
            const valorFreteNumber = parseCurrency(values.valorFrete);
            await server.put(`pedido/${values.id}`, { valorFrete: valorFreteNumber || 0 });
            if (typeof mutate === 'function') mutate();
            toast.success('Valor do frete atualizado com sucesso!');
        } catch (error) {
            setErrors(error);
        } finally {
            setSalvandoFrete(false);
        }
    }

    async function handleChangeStatusPedido(e) {
        const novoStatus = e.target.value;
        if (!values?.id || novoStatus === values.status) return;

        try {
            setSalvandoStatus(true);
            await server.put(`pedido/${values.id}`, { status: novoStatus, statusDireto: true });
            setFieldValue('status', novoStatus);
            if (typeof mutate === 'function') mutate();
            toast.success('Status atualizado com sucesso!');
        } catch (error) {
            setErrors(error);
        } finally {
            setSalvandoStatus(false);
        }
    }


    const valorTotalcalculado = (values?.valorTotal || 0) - (values?.totalRecebido || 0);
    const isAcaoProducao = Boolean(
        proximoStatusInfo?.textoBotao &&
        proximoStatusInfo.textoBotao.toLowerCase().includes('produ'),
    );
    const proximoStatusButtonClass = isAcaoProducao
        ? 'btn btn-warning border border-warning text-sm px-24 py-8 radius-8'
        : 'btn btn-success border border-success text-sm px-24 py-8 radius-8';


console.log("data", values.status)


const contrato = data?.contratos?.find(i => i)

const statusContrato = contrato?.contratoStatus
    return (
        <div className='row gy-4  '>
            <div className='card h-100 p-20  '>
                <form onSubmit={handleSubmit}>
                    <Modal show={showContratoConfirm} onHide={() => !isSubmitting && setShowContratoConfirm(false)} centered>
                        <Modal.Header closeButton>
                            <Modal.Title className="text-md d-flex align-items-center gap-2">
                                <Icon icon="mdi:file-document-edit-outline" width="22" height="22" />
                                Gerar contrato
                            </Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <div className="d-flex align-items-start gap-3">
                                <span className="w-40-px h-40-px bg-primary-50 text-primary-main d-flex justify-content-center align-items-center radius-8 flex-shrink-0">
                                    <Icon icon="mdi:file-sign" width="24" height="24" />
                                </span>
                                <div>
                                    <h6 className="text-md mb-2">Contrato ainda não gerado</h6>
                                    <p className="text-sm text-secondary-light mb-3">
                                        Confirme somente quando os dados do pedido estiverem revisados. Após a geração, o contrato ficará disponível em detalhes do contrato.
                                    </p>
                                    <div className="text-sm">
                                        <div><strong>Pedido:</strong> #{values?.id || data?.id}</div>
                                        <div><strong>Cliente:</strong> {data?.cliente?.nome || values?.cliente?.nome || 'Cliente selecionado'}</div>
                                        <div><strong>Total:</strong> {formatCurrency(data?.valorTotal || values?.valorTotal)}</div>
                                    </div>
                                </div>
                            </div>
                        </Modal.Body>
                        <Modal.Footer>
                            <button
                                type="button"
                                className="btn btn-light border text-sm px-16 py-8 radius-8"
                                // disabled={isSubmitting}
                                onClick={() => setShowContratoConfirm(false)}
                            >
                                Cancelar
                            </button>
                            <button
                                type="button"
                                className="btn btn-primary border border-primary-600 text-sm px-16 py-8 radius-8 d-inline-flex align-items-center gap-2"
                                // disabled={isSubmitting}
                                onClick={handleConfirmarContrato}
                            >
                                <Icon icon="mdi:file-document-check-outline" width="20" height="20" />
                                {isSubmitting ? 'Gerando...' : 'Gerar contrato'}
                            </button>
                        </Modal.Footer>
                    </Modal>
                    <fieldset>
                        <div className="row  ">
                            <div className="d-flex  justify-content-between align-items-center   border-bottom pb-2">
                                <small  >
                                    {Boolean(values.dataCriacao) ? `Criado em: ${new Date(values.dataCriacao).toLocaleString()} ` : 'Criando...'}
                                </small>
                                <div className='d-flex  justify-content-end align-items-center gap-2'>
                                    <button
                                        // disabled={isSubmitting || ['OPEN'].includes(values?.status) || !Boolean(values?.clienteId) || !Boolean(data?.pedidoItems?.length)}
                                        type="button"
                                        className={`btn shadow ${pagamentoRecebido ? " btn-success " : " btn-primary "}border border-primary-600 text-md px-3 py-2 radius-8`}
                                        onClick={() => handlePagamento()}
                                    >
                                        <Icon icon="mdi:attach-money" width="24" height="24" />
                                        {pagamentoRecebido ? "Pagamento recebido" : "Pagamentos"}
                                    </button>
                                    {Boolean(contrato) && (
                                        <button
                                            disabled={isSubmitting || !Boolean(values?.contratos)}
                                            type="button"
                                            className="btn shadow btn-primary border border-primary-600 text-md px-3 py-2 radius-8"
                                            onClick={() => handleContratoDetalhes()}
                                        >
                                            <Icon icon="mdi:attach-money" width="24" height="24" />
                                            Detalhes contrato
                                        </button>
                                    )}
                                    {/* <button
                                        type="button"
                                        className="btn shadow btn-secondary border border-secondary-600 text-md px-3 py-2 radius-8"
                                        onClick={() => handlePedidoExtra()}
                                    >
                                        <Icon icon="mdi:image-multiple-outline" width="24" height="24" />
                                        Imagens do pedido
                                    </button> */}
                                    {!Boolean(contrato) && (
                                        <button
                                            // disabled={isSubmitting || ['OPEN'].includes(values?.status) || !Boolean(values?.clienteId) || !Boolean(data?.pedidoItems?.length) || ["PRONTO_PARA_PRODUCAO"].includes(values.status)}
                                            type="button"
                                            className="btn shadow btn-primary border border-primary-600 text-md px-3 py-2 radius-8"
                                            onClick={() => handleContrato()}
                                        >
                                            <Icon icon="mdi:file-document-outline" width="24" height="24" />
                                            {isSubmitting ? 'Gerando contrato...' : 'Gerar contrato'}
                                        </button>
                                    )}
                                    <button
                                        type="button"
                                        className="btn shadow btn-secondary border border-secondary-600 text-md px-3 py-2 radius-8"
                                        // disabled={!podeImprimir}
                                        onClick={handleImprimir}
                                    >
                                        <Icon icon="mdi:printer" width="24" height="24" />
                                        Imprimir
                                    </button>

                                    {Boolean(data?.id) && !isFuncionario && (
                                        <button
                                            type="button"
                                            className="btn shadow btn-danger border border-danger text-md px-3 py-2 radius-8"
                                            onClick={handleExcluirPedido}
                                        >
                                            <Icon icon="mdi:trash-can-outline" width="24" height="24" />
                                            Excluir
                                        </button>
                                    )}

                                    {Boolean(values.status) && (
                                    <span className={`bg-${estilo}-focus  ms-3 shadow rounded-pill  text-${estilo}-main fw-medium px-3 py-2 radius-8`}>
                                        {statusPedidoNome[values.status]  }
                                    </span>
                                    )}
                                </div>

                            </div>

                            {/* Tabs */}
                            <ul className="d-inline-flex nav nav-pills border-gradient-tab mb-20" role="tablist">
                                <li className="nav-item" role="presentation">
                                    <button
                                        className={`d-flex nav-link align-items-center px-24 ${activeTab === 'detalhes' ? 'active' : ''}`}
                                        type="button"
                                        role="tab"
                                        onClick={() => setActiveTab('detalhes')}
                                    >
                                        Detalhes
                                    </button>
                                </li>
                                <li className="nav-item" role="presentation">
                                    <button
                                        className={`d-flex nav-link align-items-center px-24 ${activeTab === 'observacoes' ? 'active' : ''}`}
                                        type="button"
                                        role="tab"
                                        onClick={() => setActiveTab('observacoes')}
                                    >
                                        Observações
                                    </button>
                                </li>
                                <li className="nav-item" role="presentation">
                                    <button
                                        className={`d-flex nav-link align-items-center px-24 ${activeTab === 'frete' ? 'active' : ''}`}
                                        type="button"
                                        role="tab"
                                        onClick={() => setActiveTab('frete')}
                                    >
                                        Frete
                                    </button>
                                </li>
                                <li className="nav-item" role="presentation">
                                    <button
                                        className={`d-flex nav-link align-items-center px-24 ${activeTab === 'imagens' ? 'active' : ''}`}
                                        type="button"
                                        role="tab"
                                        onClick={() => setActiveTab('imagens')}
                                    >
                                        Imagens
                                    </button>
                                </li>
                            </ul>

                            <div className="tab-content">
                                {/* Tab: Detalhes */}
                                {activeTab === 'detalhes' && (
                                    <div className="tab-pane fade show active">
                                        <div className="col-12">
                                            <label htmlFor="clienteId" className="form-label">
                                                Selecione o Cliente
                                            </label>
                                            <Select
                                                isDisabled={values.status === "CONFIRMED"}
                                                id="clienteId"
                                                options={options || []}
                                                value={selecionado}
                                                onChange={(selectable) => {
                                                    setFieldValue("clienteId", selectable.value);
                                                }}
                                                onBlur={handleBlur}
                                                className={`basic-single ${touched.clienteId && errors.clienteId ? "is-invalid" : ""
                                                    }`}
                                                classNamePrefix="select"
                                                placeholder="Selecione o cliente"
                                                noOptionsMessage={() => "Nenhuma cliente encontrada"}
                                            />
                                            {touched.clienteId && errors.clienteId && (
                                                <div className="invalid-feedback d-block">{errors.clienteId}</div>
                                            )}
                                        </div>

                                        {data?.id && !isFuncionario && (
                                            <div className="col-6 mt-3">
                                                <button
                                                    disabled={isSubmitting || ["PRONTO_PARA_PRODUCAO"].includes(values.status)}
                                                    type="button"
                                                    className="btn shadow btn-primary border border-primary-600 text-md px-3 py-2 radius-8"
                                                     onClick={() => handleOpenProduct()}
                                                >
                                                    <i className="ri-box-3-line" /> Adicionar produto
                                                </button>
                                            </div>
                                        )}

                                        <div className="d-flex gap-1 mt-3">
                                            <AdicionarItem data={data} mutate={mutate} />
                                        </div>

                                        <div className='mb-3 mt-3'>
                                            <ListarItens itens={data?.pedidoItems} />
                                        </div>


                                    </div>
                                )}

                                {/* Tab: Observações */}
                                {activeTab === 'observacoes' && (
                                    <div className="tab-pane fade show active">
                                        {values?.id && (
                                            <div className="row align-items-start mb-3">
                                                <div className="col-md-4 offset-md-8 d-flex flex-column align-items-md-end">
                                                    <label htmlFor="statusPedido" className="form-label text-secondary-light text-sm mb-1">
                                                        Status do pedido
                                                    </label>
                                                    <select
                                                        id="statusPedido"
                                                        className="form-select form-select-sm w-auto"
                                                        value={values.status || ''}
                                                        disabled={isSubmitting || salvandoStatus}
                                                        onChange={handleChangeStatusPedido}
                                                    >
                                                        {Object.entries(statusPedidoNome)
                                                            .filter(([chave]) => chave !== 'OPEN')
                                                            .map(([chave, valor]) => (
                                                                <option key={chave} value={chave}>
                                                                    {valor}
                                                                </option>
                                                            ))}
                                                    </select>
                                                </div>
                                            </div>
                                        )}

                                        <div className="col-12">
                                            <label
                                                htmlFor="observacoes"
                                                className="form-label text-primary-light text-sm fw-semibold mb-8"
                                            >
                                                Observações Adicionais do Pedido
                                            </label>
                                            <textarea
                                                disabled={!values?.id}

                                                className="form-control radius-8"
                                                id="observacoes"
                                                placeholder="Informe observações adicionais sobre o pedido..."
                                                rows={6}
                                                {...getFieldProps('observacoes')}
                                            />
                                            {touched.observacoes && errors.observacoes && (
                                                <div className="invalid-feedback d-block">{errors.observacoes}</div>
                                            )}
                                        </div>
                                    </div>
                                )}

                                {/* Tab: Frete */}
                                {activeTab === 'frete' && (
                                    <div className="tab-pane fade show active">
                                        <div className="row gy-4">
                                            <div className="col-lg-6">
                                                <div className="card border radius-12 h-100">
                                                    <div className="card-body p-20">
                                                        <div className="d-flex align-items-center gap-2 mb-16">
                                                            <span className="w-40-px h-40-px bg-primary-50 text-primary-main d-flex justify-content-center align-items-center radius-8 flex-shrink-0">
                                                                <Icon icon="mdi:map-marker-outline" width="22" height="22" />
                                                            </span>
                                                            <h6 className="mb-0 text-md">Endereço de entrega</h6>
                                                        </div>

                                                        <label htmlFor="enderecoId" className="form-label text-secondary-light text-sm">
                                                            Selecione o endereço do cliente
                                                        </label>
                                                        <Select
                                                            isDisabled={values.status === "CONFIRMED"}
                                                            id="enderecoId"
                                                            options={enderecoOpcoes}
                                                            value={enderecoSelecionado}
                                                            onChange={(selectable) => {
                                                                setFieldValue('enderecoId', selectable?.value ?? '');
                                                            }}
                                                            onBlur={handleBlur}
                                                            className={`basic-single ${touched.enderecoId && errors.enderecoId ? 'is-invalid' : ''
                                                                }`}
                                                            classNamePrefix="select"
                                                            placeholder="Selecione o endereço do cliente"
                                                            noOptionsMessage={() => 'Nenhum endereço encontrado'}
                                                        />
                                                        {touched.enderecoId && errors.enderecoId && (
                                                            <div className="invalid-feedback d-block">{errors.enderecoId}</div>
                                                        )}

                                                        {enderecoSelecionado?.dataEndereco ? (
                                                            <div className="mt-20 pt-16 border-top">
                                                                <div className="d-flex flex-column gap-8 text-sm">
                                                                    <div className="d-flex align-items-start gap-2">
                                                                        <Icon icon="mdi:road-variant" className="text-secondary-light flex-shrink-0 mt-1" width="18" height="18" />
                                                                        <span className="text-neutral-900 fw-medium">
                                                                            {[enderecoSelecionado.dataEndereco.logradouro, enderecoSelecionado.dataEndereco.numero].filter(Boolean).join(', ')}
                                                                            {Boolean(enderecoSelecionado.dataEndereco.complemento) && ` — ${enderecoSelecionado.dataEndereco.complemento}`}
                                                                        </span>
                                                                    </div>
                                                                    <div className="d-flex align-items-start gap-2">
                                                                        <Icon icon="mdi:home-city-outline" className="text-secondary-light flex-shrink-0 mt-1" width="18" height="18" />
                                                                        <span className="text-secondary-light">
                                                                            {[enderecoSelecionado.dataEndereco.bairro, enderecoSelecionado.dataEndereco.cidade, enderecoSelecionado.dataEndereco.estado].filter(Boolean).join(' - ')}
                                                                        </span>
                                                                    </div>
                                                                    <div className="d-flex align-items-start gap-2">
                                                                        <Icon icon="mdi:mailbox-outline" className="text-secondary-light flex-shrink-0 mt-1" width="18" height="18" />
                                                                        <span className="text-secondary-light">
                                                                            CEP {enderecoSelecionado.dataEndereco.cep}
                                                                            {Boolean(enderecoSelecionado.dataEndereco.pais) && ` · ${enderecoSelecionado.dataEndereco.pais}`}
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        ) : (
                                                            <div className="mt-20 pt-16 border-top text-center text-secondary-light text-sm">
                                                                Nenhum endereço selecionado.
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="col-lg-6">
                                                <div className="card border radius-12 h-100">
                                                    <div className="card-body p-20">
                                                        <div className="d-flex align-items-center gap-2 mb-16">
                                                            <span className="w-40-px h-40-px bg-primary-50 text-primary-main d-flex justify-content-center align-items-center radius-8 flex-shrink-0">
                                                                <Icon icon="mdi:truck-fast-outline" width="22" height="22" />
                                                            </span>
                                                            <h6 className="mb-0 text-md">Frete</h6>
                                                        </div>

                                                        <div className="mb-20">
                                                            <label htmlFor="tipoFreteId" className="form-label text-secondary-light text-sm">
                                                                Tipo de frete
                                                            </label>
                                                            <div className="d-flex align-items-start gap-2">
                                                                <div className="flex-grow-1">
                                                                    <Select
                                                                        id="tipoFreteId"
                                                                        isDisabled={salvandoFrete}
                                                                        options={tiposFrete?.map(t => ({ value: t.id, label: t.nome })) || []}
                                                                        value={
                                                                            tiposFrete
                                                                                ?.map(t => ({ value: t.id, label: t.nome }))
                                                                                .find(opt => opt.value === values.tipoFreteId) || null
                                                                        }
                                                                        onChange={(selectable) => handleChangeTipoFrete(selectable?.value ?? '')}
                                                                        classNamePrefix="select"
                                                                        placeholder="Selecione o tipo de frete"
                                                                        noOptionsMessage={() => 'Nenhum tipo cadastrado'}
                                                                    />
                                                                </div>
                                                                <button
                                                                    type="button"
                                                                    title="Cadastrar novo tipo de frete"
                                                                    className="btn btn-light border border-neutral-300 text-sm px-3 py-2 radius-8 flex-shrink-0"
                                                                    onClick={() => setShowTipoFreteModal(true)}
                                                                >
                                                                    <Icon icon="ic:baseline-plus" width="18" height="18" />
                                                                </button>
                                                            </div>
                                                        </div>

                                                        <div>
                                                            <label htmlFor="valorFrete" className="form-label text-secondary-light text-sm">
                                                                Valor do frete
                                                            </label>
                                                            <PriceInputMasked
                                                                {...getFieldProps('valorFrete')}
                                                                disabled={salvandoFrete}
                                                                onBlur={(e) => { handleBlur(e); handleSalvarValorFrete(); }}
                                                                className="form-control radius-8"
                                                                id="valorFrete"
                                                                placeholder="Ex: R$ 35,00"
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}

                                {activeTab === 'imagens' && (
                                    <PedidoImagesTab data={data} mutate={mutate} />
                                )}
                            </div>

                            <footer className="card-footer bg-white mt-10">
                                {/* <div>
                                        <button
                                            type="button"
                                            className="btn shadow btn-success border border-secondary-600 text-md px-3 py-2 radius-8"
                                            disabled={!podeImprimir || ["PRONTO_PARA_PRODUCAO"].includes(values.status)}
                                            onClick={handleEnviarProducao}
                                        >
                                            <Icon icon="mdi:tools" width="24" height="24" />
                                            Produzir
                                        </button>
                                    </div> */}
                                <div className="d-flex flex-column flex-lg-row justify-content-between align-items-stretch align-items-lg-center gap-3 w-100">
                                    <div className="d-flex flex-wrap align-items-center gap-2 flex-grow-1">


                                        <span className="fw-bold shadow text-md bg-light border rounded px-3 py-2 radius-8">
                                            Sub-total:{' '}
                                            {Boolean(values?.subTotal)
                                                ? formatCurrency(values?.subTotal)
                                                : '0.0'}
                                        </span>
                                        <span className="fw-bold shadow text-md bg-light border rounded px-3 py-2 radius-8">
                                            Total Bruto:{' '}
                                            {Boolean(values?.valorTotal)
                                                ? formatCurrency(values?.valorTotal)
                                                : '0.0'}
                                        </span>
                                        <span className="fw-bold shadow text-md bg-light border rounded px-3 py-2 radius-8">
                                            Total Recebido:{' '}
                                            {Boolean(values?.totalRecebido)
                                                ? formatCurrency(values?.totalRecebido)
                                                : '0.0'}
                                        </span>
                                        <span className="fw-bold shadow text-md bg-light border rounded px-3 py-2 radius-8">
                                            Total a receber:{' '}
                                            {Boolean(values?.valorTotal)
                                                ? formatCurrency(valorTotalcalculado)
                                                : '0.0'}
                                        </span>
                                    </div>
                                    <div className="d-flex flex-wrap align-items-center justify-content-lg-end gap-2 flex-shrink-0 ms-lg-auto">
                                        <>

                                        </>
                                        {proximoStatusInfo && (
                                            //Aqui ~e o botao de atualizar o status 

                                            <button
                                                type="button"
                                                className={proximoStatusButtonClass}
                                                disabled={isSubmitting}
                                                onClick={handleAvancarStatus}
                                            >
                                                {isSubmitting ? 'Atualizando...' : proximoStatusInfo.textoBotao}
                                            </button>
                                        )}
                                            {isFuncionario && (
                                              <button
                                                type="button"
                                                className="btn btn-primary border border-primary-600 text-sm px-24 py-8 radius-8"
                                                onClick={() => navigate(backTo)}
                                              >
                                                Voltar
                                              </button>
                                            )}
                                            {isFuncionario && (
                                              <button
                                                type="submit"
                                                  className="btn btn-success border border-success text-sm px-24 py-8 radius-8"
                                                  disabled={isSubmitting}
                                                  onClick={() => {
                                                      setFieldValue('action', 'update');
                                                  }}
                                            >
                                                {isSubmitting ? 'Salvando...' : 'Salvar Observações'}
                                            </button>
                                        )}
                                            {!isFuncionario && (
                                              <button
                                                type="button"
                                                className="btn btn-primary border border-primary-600 text-sm px-24 py-8 radius-8"
                                                onClick={() => navigate(backTo)}
                                              >
                                                Voltar
                                              </button>
                                            )}
                                            {!isFuncionario && (
                                              <button
                                                type="submit"
                                                  className="btn btn-success border border-success text-sm px-24 py-8 radius-8"
                                                  disabled={isSubmitting || !isValid || !Boolean(values?.clienteId)}
                                              >
                                                {isSubmitting ? 'Salvando...' : 'Salvar'}
                                              </button>
                                        )}

                                    </div>

                                </div>
                            </footer>
                        </div>

                    </fieldset>
                    <div className="d-flex gap-1">
                        <AddPayment data={data} mutate={mutate} />
                    </div>
                    <div className="d-flex gap-1">
                        <ContratoDetalhes data={data} mutate={mutate} />
                        {/* <Upload data={data} mutate={mutate} /> */}
                    </div>
                    <PedidoPdf ref={pdfRef} pedido={data} />
                    <div className="d-flex gap-1">
                        <AddPayment data={data} mutate={mutate} />
                    </div>
                    <div className="d-flex gap-1">
                        <ContratoDetalhes data={data} mutate={mutate} />
                        {/* <Upload data={data} mutate={mutate} /> */}
                    </div>
                </form>

                <Modal show={showTipoFreteModal} onHide={() => !submittingTipoFrete && setShowTipoFreteModal(false)} centered>
                    <Modal.Header closeButton>
                        <Modal.Title className="text-md">Novo tipo de frete</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <form id="form-tipo-frete" onSubmit={handleCadastrarTipoFrete}>
                            <label className="form-label">
                                Nome <span className="text-danger-600">*</span>
                            </label>
                            <input
                                type="text"
                                className="form-control radius-8"
                                value={novoTipoFreteNome}
                                onChange={(e) => setNovoTipoFreteNome(e.target.value)}
                                placeholder="Ex: Correios, Transportadora, Motoboy"
                                autoComplete="off"
                                autoFocus
                            />
                        </form>
                    </Modal.Body>
                    <Modal.Footer>
                        <button
                            type="button"
                            className="btn btn-light border radius-8"
                            disabled={submittingTipoFrete}
                            onClick={() => setShowTipoFreteModal(false)}
                        >
                            Cancelar
                        </button>
                        <button
                            type="submit"
                            form="form-tipo-frete"
                            className="btn btn-primary radius-8"
                            disabled={submittingTipoFrete}
                        >
                            {submittingTipoFrete ? 'Salvando...' : 'Cadastrar'}
                        </button>
                    </Modal.Footer>
                </Modal>
            </div>
        </div >
    );
};

function AdicionarItem({ data, mutate }) {
    const { id, open } = useDialog('product');
    if (Boolean(id) && open) {
        return <EditItemProduct data={data} id={id} mutate={mutate} />;
    }

    if (open) return <ItemPedidoModal data={data} mutate={mutate} />;
}

function EditItemProduct({ data, id, mutate }) {
    const { data: item } = useFetch(`pedido/${data?.id}/item/${id}`);

    return <ItemPedidoModal item={item} data={data} mutate={mutate} />;
}

function ListarItens({ itens }) {
    const { handleOpen } = useDialog('product');
    const { handleOpen: handleOpenProduct } = useDialog('product');
    return <>
        {Boolean(itens?.length > 0) && (
            <table className="table table-bordered table-striped">
                <thead>
                    <tr>
                        <th>ID</th>
                        <th>Nome</th>
                        <th>Valor Unitario</th>
                        <th>Valor Total</th>
                        <th>Quantidade</th>
                    </tr>
                </thead>
                <tbody>
                    {(itens || []).map(item => (
                        <tr key={item.id}>
                            <td>{item.id}</td>
                            <td>{item?.nomeItem}</td>
                            <td>{formatCurrency(item.valorUnitario)}</td>
                            <td>{formatCurrency(item.valorTotal)}</td>

                            <td>{item.quantidade || item.qtd}</td>
                            <td>
                                <button
                                    // disabled={(['CONFIRMED'].includes(data?.status) && !["Exceeded", 'returned'].includes(item.type)) || ['CLOSED'].includes(data?.status)}
                                    type='button'
                                    title='Editar item'
                                    onClick={
                                        item.product_id ? () => handleOpenProduct(item.id) : () => handleOpen(item.id)}
                                    className="d-inline-flex align-items-center bg-success-focus w-40-px h-40-px justify-content-center rounded-circle text-success-main w-32-px me-8"
                                >
                                    <Icon icon="lucide:edit" />
                                </button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        )}

        {/* {!Boolean(itens?.length > 0) && (

            <h1>Esse pedido nao tem item</h1>
        )} */}



    </>

}

function AddPayment({ data, mutate }) {
    const { id, open } = useDialog('payment');

    if (open) return <OrderPaymentModal data={data} mutate={mutate} />;
}

function ContratoDetalhes({ data, mutate }) {
    const { id, open } = useDialog('contrato');

    if (open) return <PedidoContratoModal data={data} mutate={mutate} />;
}

// function Upload({ data, mutate }) {
//     const { open } = useDialog('pedidoExtra');
//
//     if (open) return <UploadImagensModal data={data} mutate={mutate} />;
// }

export default ViewPedidosLayer;
